import Card from "@mui/material/Card";
import { Grid, Tooltip } from "@mui/material";
import { useState } from "react";
import { TrackerRelationshipsService } from "../../services/trackerRelationships";
import styles from "./card.module.scss";
import { CardStateIcons } from "./cardStateIcons";
import { DetailsModalChart } from "./detailsCardChart";
import moment from "moment";
import { Button } from "antd";
import "moment-timezone";

moment.tz.setDefault("America/Sao_Paulo");

export const FarmCard = ({ card }) => {
  const [sensorDataToChart, setSensorDataToChart] = useState([]);
  const [open, setOpen] = useState(false);
  const [loadingSensorData, setLoadingSensorData] = useState(true);
  const [alarms, setAlarms] = useState([]);
  const trackerRelationshipsService = new TrackerRelationshipsService();
  const [lastUpdate, setLastUpdate] = useState("");
  const [vehicleDetailsTimer, setVehicleDetailsTimer] = useState();

  const handleDetailsClick = (e) => {
    setOpen(true);
    getDataToChart(card.trackerRelationshipId);
    const id_update_chart_farm = setInterval(() => {
      getDataToChart(card.trackerRelationshipId);
    }, 60000);
    setVehicleDetailsTimer(id_update_chart_farm);
    sessionStorage.setItem("id_update_chart_farm", id_update_chart_farm);
  };

  const handleCloseDetailsModal = () => {
    setOpen(false);
    setVehicleDetailsTimer(clearInterval(vehicleDetailsTimer));
    sessionStorage.removeItem("id_update_chart_farm");
  };

  const getDataToChart = (trackerRelationShipId) => {
    trackerRelationshipsService
      .getDetailsCard(trackerRelationShipId, "all")
      .then((res) => {
        setLastUpdate(
          moment(res.data.lista1[res.data.lista1.length - 1].dtEvent).format(
            "DD/MM/YYYY HH:mm:ss"
          )
        );
        handleSensorDataResponse(res.data.lista1);
        setAlarms(res.data.lista2);
        setLoadingSensorData(false);
      })
      .catch((err) => {
        setLoadingSensorData(false);
      });
  };

  const handleSensorDataResponse = (sensorData) => {
    let labels = [];
    let sensor1Data = [];
    let sensor2Data = [];
    let sensor3Data = [];
    let sensor4Data = [];
    let sensor5Data = [];
    let sensor6Data = [];
    let sensor7Data = [];
    let sensor8Data = [];
    let sensor9Data = [];

    let sensor1Values = [];
    let sensor2Values = [];
    let sensor3Values = [];
    let sensor4Values = [];
    let sensor5Values = [];
    let sensor6Values = [];
    let sensor7Values = [];
    let sensor71Values = [];
    let sensor72Values = [];
    let sensor8Values = [];
    let sensor81Values = [];
    let sensor82Values = [];
    let sensor9Values = [];

    let sensorMinThresholdValuesTemp = [];
    let sensorMaxThresholdValuesTemp = [];
    let sensorMinThresholdValuesHum = [];
    let sensorMaxThresholdValuesHum = [];
    let sensorMinThresholdValuesCO2 = [];
    let sensorMaxThresholdValuesCO2 = [];

    sensor1Data = sensorData.filter(
      (i) => i.sensorName === "Internal Temperature 1"
    );
    sensor2Data = sensorData.filter(
      (i) => i.sensorName === "Internal Temperature 2"
    );
    sensor3Data = sensorData.filter(
      (i) => i.sensorName === "External Temperature"
    );
    sensor4Data = sensorData.filter((i) => i.sensorName === "Humidity 1");
    sensor5Data = sensorData.filter((i) => i.sensorName === "Humidity 2");
    sensor6Data = sensorData.filter((i) => i.sensorName === "CO2");
    sensor7Data = sensorData.filter((i) => i.sensorName === "ThermoKing");
    sensor8Data = sensorData.filter((i) => i.sensorName === "Port");
    sensor9Data = sensorData.filter(
      (i) => i.sensorName === "Average Temperature"
    );

    for (let i = 0; i < sensor1Data.length; i++) {
      if (i < sensor1Data.length - 1) {
        sensor1Values.push(
          parseFloat(sensor1Data[i].sensorValue.replace(",", ".")).toFixed(2)
        );
        labels.push(sensor1Data[i].dtEvent);
        sensorMinThresholdValuesTemp.push(
          parseFloat(
            sensor1Data[i].sensorMinThreshold.replace(",", ".")
          ).toFixed(2)
        );
        sensorMaxThresholdValuesTemp.push(
          parseFloat(
            sensor1Data[i].sensorMaxThreshold.replace(",", ".")
          ).toFixed(2)
        );
      }
    }

    for (let i = 0; i < sensor2Data.length; i++) {
      if (i < sensor2Data.length - 1) {
        sensor2Values.push(
          parseFloat(sensor2Data[i].sensorValue.replace(",", "."))
        );
      }
    }

    for (let i = 0; i < sensor3Data.length; i++) {
      if (i < sensor3Data.length - 1) {
        sensor3Values.push(
          parseFloat(sensor3Data[i].sensorValue.replace(",", "."))
        );
      }
    }

    for (let i = 0; i < sensor9Data.length; i++) {
      if (i < sensor9Data.length - 1) {
        sensor9Values.push(
          parseFloat(sensor9Data[i].sensorValue.replace(",", "."))
        );
      }
    }

    for (let i = 0; i < sensor4Data.length; i++) {
      if (i < sensor4Data.length - 1) {
        sensor4Values.push(
          parseFloat(sensor4Data[i].sensorValue.replace(",", "."))
        );
        sensorMinThresholdValuesHum.push(
          parseFloat(sensor4Data[i].sensorMinThreshold.replace(",", "."))
        );
        sensorMaxThresholdValuesHum.push(
          parseFloat(sensor4Data[i].sensorMaxThreshold.replace(",", "."))
        );
      }
    }

    for (let i = 0; i < sensor5Data.length; i++) {
      if (i < sensor5Data.length - 1) {
        sensor5Values.push(
          parseFloat(sensor5Data[i].sensorValue.replace(",", "."))
        );
      }
    }

    for (let i = 0; i < sensor6Data.length; i++) {
      if (i < sensor6Data.length - 1) {
        sensor6Values.push(
          parseFloat(sensor6Data[i].sensorValue.replace(",", "."))
        );
        sensorMinThresholdValuesCO2.push(
          parseFloat(sensor6Data[i].sensorMinThreshold.replace(",", "."))
        );
        sensorMaxThresholdValuesCO2.push(
          parseFloat(sensor6Data[i].sensorMaxThreshold.replace(",", "."))
        );
      }
    }

    for (let i = 0; i < sensor7Data.length; i++) {
      if (i < sensor7Data.length - 1) {
        sensor7Values.push(
          sensor7Data[i].sensorValue.replace("ON", parseInt(0))
        );
        sensor71Values.push(
          sensor7Data[i].sensorValue === "OFF"
            ? sensor7Data[i].sensorValue.replace("OFF", parseInt(0))
            : "OFF_ATTENTION"
        );
        sensor72Values.push(
          sensor7Data[i].sensorValue === "OFF"
            ? sensor7Data[i].sensorValue.replace("OFF", parseInt(0))
            : "OFF_ATTENTION"
        );
      }
    }

    for (let i = 0; i < sensor8Data.length; i++) {
      if (i < sensor8Data.length - 1) {
        sensor8Values.push(
          sensor8Data[i].sensorValue.replace("True", parseInt(1))
        );
        sensor82Values.push(
          sensor8Data[i].sensorValue === "False"
            ? sensor8Data[i].sensorValue.replace("False", parseInt(1))
            : NaN
        );
      }

      const dataToChart = {
        labels: labels,
        sensor1Values: sensor1Values,
        sensor2Values: sensor2Values,
        sensor3Values: sensor3Values,
        sensor4Values: sensor4Values,
        sensor5Values: sensor5Values,
        sensor6Values: sensor6Values,
        sensor7Values: sensor7Values,
        sensor71Values: sensor71Values,
        sensor72Values: sensor72Values,
        sensor8Values: sensor8Values,
        sensor81Values: sensor81Values,
        sensor82Values: sensor82Values,
        sensor9Values: sensor9Values,
        sensorMinThresholdValuesTemp: sensorMinThresholdValuesTemp,
        sensorMaxThresholdValuesTemp: sensorMaxThresholdValuesTemp,
        sensorMinThresholdValuesHum: sensorMinThresholdValuesHum,
        sensorMaxThresholdValuesHum: sensorMaxThresholdValuesHum,
        sensorMinThresholdValuesCO2: sensorMinThresholdValuesCO2,
        sensorMaxThresholdValuesCO2: sensorMaxThresholdValuesCO2,
      };
      setSensorDataToChart(dataToChart);
    }
  };
  return (
    <div>
      <Card className={styles.card}>
        <Grid container>
          <Grid item xs={12} className={styles.name}>
            {card.vehiclePlate}
          </Grid>

          <Grid item xl={6} lg={6} md={6} sm={6} xs={6}>
            <CardStateIcons
              numberOfEvents={card.numberOfEvents}
              driverAwareness={card.isDriverAware}
              ignition={card.ignition}
              speed={card.vehicleSpeed}
              thermoKing={card.thermoKing}
              isAlarmActived={card.isAlarmActived}
              door={card.isDoorOpen}
            />
          </Grid>

          <Grid
            item
            xl={6}
            lg={6}
            md={6}
            sm={6}
            xs={6}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
            }}
          >
            <Tooltip title="Ver Detalhes">
              <Button
                type="primary"
                className={styles.detailsButton}
                onClick={(e) => {
                  handleDetailsClick(e);
                }}
              >
                DETALHES
              </Button>
            </Tooltip>
          </Grid>
        </Grid>
      </Card>
      <DetailsModalChart
        open={open}
        handleOnClose={handleCloseDetailsModal}
        dataToChartLine={sensorDataToChart}
        alarms={alarms}
        loadingSensorData={loadingSensorData}
        cardId={card.trackerRelationshipId}
        lastUpdate={lastUpdate}
      />
    </div>
  );
};
